var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"title":_vm.title,"app-bar-class":"primary--text text-uppercase","bg-class":"secondary","dark":false}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }